import { useContext, useMemo } from 'react';
import { CONSTANT } from '@const';
import { UserTypeContext } from '@context';
import { msalService } from '@services';
import { WaterIQUserType } from '@types';
import { cn, linkTarget, useLogout } from '@utils';

import { GlobalNav, Home, Logout, Phone } from '../icons';
import { CTAItem, NavigationItem } from './types';

export const useMenuItems = () => {
	const logout = useLogout();
	const { setSelectedUserType } = useContext(UserTypeContext);

	const availableUserTypes = useMemo(() => msalService.getUserTypes(), []);
	const isAccountClosed = msalService.isClosedAccount();

	const menuItems: NavigationItem[] = [];
	if (!isAccountClosed) {
		menuItems.push(
			{
				href: CONSTANT.DQP_HOME_PAGE,
				icon: active => (
					<Home
						className={cn(
							'text-light-action-secondary size-icon-md group-hover:text-light-action-primary-hover',
							active && 'text-light-heading',
						)}
					/>
				),
				iconLabel: 'Meter inspections',
			},
			{
				href: '/account-details',
				label: 'Account details',
			},
		);
		if (CONSTANT.IS_DEV) {
			menuItems.push({
				href: '/playground',
				label: 'Playground',
			});
		}
	}

	const callToActionItems: CTAItem[] = [
		{
			icon: <Logout className="text-dark-action-secondary size-icon-md" />,
			label: 'Switch to WEH portal',
			onClick: () => {
				setSelectedUserType(WaterIQUserType.WEH);
			},
			visible: !isAccountClosed && (availableUserTypes ?? []).length > 1,
		},
		{
			icon: <GlobalNav className="text-dark-action-secondary size-icon-md" />,
			label: 'Queensland Government websites',
			onClick: () => {
				window.open(CONSTANT.QLD_GOV_URL, linkTarget(CONSTANT.QLD_GOV_URL));
			},
			visible: !isAccountClosed,
		},
		{
			icon: <Logout className="text-dark-action-secondary size-icon-md" />,
			label: 'Log-out',
			onClick: logout,
			visible: true,
		},
		{
			icon: <Phone className="text-dark-action-secondary size-icon-md" />,
			label: (
				<>
					<b>Phone:</b>&nbsp;
					{CONSTANT.WATERIQ_PHONE_NUMBER}
				</>
			),
			onClick: () => (window.location.href = `tel:${CONSTANT.WATERIQ_PHONE_NUMBER}`),
			visible: !isAccountClosed,
		},
	];

	return { menuItems, callToActionItems };
};
